import { Group, Box, Text, Badge, Progress } from '@mantine/core';
import { Check } from 'react-feather';
import type { OverviewMilestoneProgress } from '../../../../types';

interface MilestoneItemProps {
  milestone: OverviewMilestoneProgress;
  index: number;
}

export function MilestoneItem({ milestone, index }: MilestoneItemProps) {
  const isInProgress = milestone.status === 'in_progress';
  const isCompleted = milestone.status === 'completed';

  return (
    <Box
      py="sm"
      px="md"
      style={{
        borderLeft: isInProgress
          ? '3px solid var(--mantine-color-warningAmber-5)'
          : '3px solid transparent',
        backgroundColor: isInProgress
          ? 'var(--mantine-color-warningAmber-0)'
          : undefined,
      }}
    >
      <Group justify="space-between" wrap="nowrap">
        <Group gap="sm" wrap="nowrap">
          {/* Status badge or check icon */}
          {isCompleted ? (
            <Box
              style={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: 'var(--mantine-color-medleyGreen-6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Check size={14} color="white" />
            </Box>
          ) : (
            <Badge
              size="lg"
              radius="xl"
              variant={isInProgress ? 'filled' : 'light'}
              color={isInProgress ? 'warningAmber' : 'gray'}
              style={{ minWidth: 24, height: 24, padding: '0 6px' }}
            >
              {index + 1}
            </Badge>
          )}

          {/* Phase name */}
          <Box>
            <Text
              size="sm"
              fw={500}
              style={
                isCompleted ? { textDecoration: 'line-through' } : undefined
              }
              c={isCompleted ? 'dimmed' : undefined}
            >
              {milestone.phaseName}
            </Text>
            {milestone.subGroups.length > 0 && (
              <Text size="xs" c="dimmed">
                {milestone.subGroups.join(', ')}
              </Text>
            )}
          </Box>
        </Group>

        {/* Progress info */}
        <Box style={{ textAlign: 'right', minWidth: 80 }}>
          <Text size="xs" c="dimmed">
            {milestone.tasksCompleted}/{milestone.tasksTotal} tasks
          </Text>
          {milestone.tasksTotal > 0 && (
            <Progress
              value={milestone.progressPercent}
              size="xs"
              radius="xl"
              color={
                isCompleted
                  ? 'medleyGreen'
                  : isInProgress
                    ? 'warningAmber'
                    : 'gray'
              }
              mt={4}
              style={{ width: 60, marginLeft: 'auto' }}
            />
          )}
        </Box>
      </Group>
    </Box>
  );
}

export default MilestoneItem;
